import React from 'react';
import { object, string } from 'yup';
import { useTranslation } from 'react-i18next';

import { env } from '../../config';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

const schema = object().shape({
  district: string().required(),
  stage: string().required(),
});
const defaults = {
  title: {
    en: '',
    zhhk: '',
  },
  district: '',
  stage: '',
  studentCount: 0,

  settings: {
    studentRanking: {
      all: true,
      district: true,
      school: true,
      schoolClass: true,
    },
    schoolClassRanking: {
      all: true,
      district: true,
      school: true,
    },
    showTopRanksOnly: 0,
  },
};

const FormSchool = ({
  school,
  onSubmit,
}) => {
  const { t, i18n: { language } } = useTranslation();

  return (
  <FormResource
    {...{
      defaults,
      schema,
      stored: school,
      api: '/api/core/schools',
      onSubmit,
    }}
  >
    <div className="row">
      <div className="col-8">
        <FormGroup name="title.en" label={t('Name (English)')} />
        <FormGroup name="title.zhhk" label={t('Name (Chinese)')} />
        <FormGroup name="district" label={t('District')} as="select">
          <option value=""> - </option>
          {Object.keys(env.districts).map((key) => (
            <option key={key} value={key}>
              {env.districts[key][language === 'en' ? 'en' : 'zhhk']}
            </option>
          ))}
        </FormGroup>
        <FormGroup name="stage" label={t('Stage')} as="select">
          <option value=""> - </option>
          <option value="p">{t('Primary School')}</option>
          <option value="s">{t('Secondary School')}</option>
        </FormGroup>
        <FormGroup name="studentCount" label={t('Student Count')} type="number" />
        <FormGroup name="settings.showTopRanksOnly" label={t('Show Top Ranks Only')} as="select">
          <option value="0">{t('Show All')}</option>
          <option value="15">15</option>
          <option value="30">30</option>
        </FormGroup>
      </div>
      <div className="col">
        <h4>{t('Join Personal Ranking')}?</h4>
        <p className="small mt-n1">
          {t('In which group will the students compete on')}
        </p>
        <div className="my-2">
          <FormCheckGroup
            name="settings.studentRanking.all"
            label={t('All Hong Kong')}
            type="checkbox"
            asSwitch
          />
        </div>
        <div className="my-2">
          <FormCheckGroup
            name="settings.studentRanking.district"
            label={t('All District')}
            type="checkbox"
            asSwitch
          />
        </div>
        <div className="my-2">
          <FormCheckGroup
            name="settings.studentRanking.school"
            label={t('Schools')}
            type="checkbox"
            asSwitch
          />
        </div>
        <div className="my-2">
          <FormCheckGroup
            name="settings.studentRanking.schoolClass"
            label={t('Class and Grade')}
            type="checkbox"
            asSwitch
          />
        </div>

        <h4 className="mt-5">{t('Join Group Ranking')}?</h4>
        <p className="small mt-n1">
          {t('Competition between classes')}
        </p>
        <div className="my-2">
          <FormCheckGroup
            name="settings.schoolClassRanking.all"
            label={t('All Hong Kong')}
            type="checkbox"
            asSwitch
          />
        </div>
        <div className="my-2">
          <FormCheckGroup
            name="settings.schoolClassRanking.district"
            label={t('All District')}
            type="checkbox"
            asSwitch
          />
        </div>
        <div className="my-2">
          <FormCheckGroup
            name="settings.schoolClassRanking.school"
            label={t('Schools')}
            type="checkbox"
            asSwitch
          />
        </div>
      </div>
    </div>
  </FormResource>
  );
};

export default FormSchool;
